import { createStore } from "zustand/vanilla";
import type { KeyValueStorage } from "../adapters";

/**
 * What the push offer remembers on this device: that the person acted on an
 * order or a call here (`engaged`), and when they last said "Not now".
 */
export type PushPromptState = {
	engaged: boolean;
	dismissedAt: number | null;
	engage(): void;
	dismiss(at: number): void;
};

const ENGAGED = "luckymenu.push.engaged";
const DISMISSED = "luckymenu.push.dismissedAt";

export type PushPromptStore = ReturnType<typeof createPushPromptStore>;

export function createPushPromptStore(storage: KeyValueStorage) {
	const store = createStore<PushPromptState>((set, get) => ({
		engaged: false,
		dismissedAt: null,
		engage() {
			if (get().engaged) return;
			set({ engaged: true });
			void storage.setItem(ENGAGED, "1").catch(() => {});
		},
		dismiss(at) {
			set({ dismissedAt: at });
			void storage.setItem(DISMISSED, String(at)).catch(() => {});
		},
	}));
	void Promise.all([
		storage.getItem(ENGAGED).catch(() => null),
		storage.getItem(DISMISSED).catch(() => null),
	]).then(([engaged, dismissed]) => {
		const at = dismissed ? Number(dismissed) : Number.NaN;
		store.setState((s) => ({
			engaged: s.engaged || engaged === "1",
			dismissedAt: s.dismissedAt ?? (Number.isFinite(at) ? at : null),
		}));
	});
	return store;
}
